"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FluidLayoutCustomizer = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2022 GoodData Corporation
var sdk_model_1 = require("@gooddata/sdk-model");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var cloneDeep_1 = tslib_1.__importDefault(require("lodash/cloneDeep"));
var fluidLayout_1 = require("../../_staging/dashboard/fluidLayout");
var FluidLayoutCustomizer = /** @class */ (function () {
    function FluidLayoutCustomizer(logger, mutationContext) {
        var _this = this;
        this.logger = logger;
        this.mutationContext = mutationContext;
        this.addItemOps = [];
        this.addSectionOps = [];
        this.addItem = function (sectionIdx, itemIdx, item) {
            if (!item.widget) {
                _this.logger.warn("Item to add to section " + sectionIdx + " at index " + itemIdx + " does not contain any widget. The item will not be added at all.", item);
                return _this;
            }
            _this.addItemOps.push({
                sectionIdx: sectionIdx,
                itemIdx: itemIdx,
                item: cloneDeep_1.default(item),
            });
            return _this;
        };
        this.addSection = function (sectionIdx, section) {
            if (isEmpty_1.default(section.items)) {
                _this.logger.warn("Section to add at index " + sectionIdx + " contains no items. The section will not be added at all.", section);
                return _this;
            }
            var itemsWithoutWidget = section.items.filter(function (item) { return item.widget === undefined; });
            if (!isEmpty_1.default(itemsWithoutWidget)) {
                _this.logger.warn("Section to add at index " + sectionIdx + " contains items that do not specify any widgets. The section will not be added at all.", section);
                return _this;
            }
            _this.addSectionOps.push({
                sectionIdx: sectionIdx,
                section: cloneDeep_1.default(section),
            });
            return _this;
        };
        this.applyTransformations = function (layout) {
            var builder = fluidLayout_1.DashboardLayoutBuilder.for(layout);
            var facade = builder.facade();
            var layouts = _this.mutationContext.layouts;
            _this.addItemOps.forEach(function (op) {
                var sectionIdx = op.sectionIdx, itemIdx = op.itemIdx, item = op.item;
                var actualSectionIdx = sectionIdx === -1 ? facade.sections().count() : sectionIdx;
                builder.modifySection(actualSectionIdx, function (sectionBuilder) {
                    sectionBuilder.addItem(item, itemIdx === -1 ? undefined : itemIdx);
                    if (item.widget) {
                        layouts[sdk_model_1.objRefToString(item.widget)] = "inserted";
                    }
                    return sectionBuilder;
                });
            });
            _this.addSectionOps.forEach(function (op) {
                var sectionIdx = op.sectionIdx, section = op.section;
                builder.addSection(section, sectionIdx === -1 ? undefined : sectionIdx);
                section.items.forEach(function (item) {
                    if (item.widget) {
                        layouts[sdk_model_1.objRefToString(item.widget)] = "inserted";
                    }
                });
            });
            return builder.build();
        };
    }
    return FluidLayoutCustomizer;
}());
exports.FluidLayoutCustomizer = FluidLayoutCustomizer;
//# sourceMappingURL=fluidLayoutCustomizer.js.map